<template>
  <a v-if="href" :href="href" class="lp-breadcrumb-button btn-link">
    <lp-icon :name="icon" />
    {{ label }}
  </a>
  <button
    v-else-if="onClick"
    class="lp-breadcrumb-button btn-link"
    @click="onClick"
  >
    <lp-icon :name="icon" />
    {{ label }}
  </button>
  <button v-else class="lp-breadcrumb-button btn-link" @click="goBack">
    <lp-icon :name="icon" />
    {{ label }}
  </button>
</template>

<script setup lang="ts">
import LpIcon from '@/components/icon/LpIcon.vue'

interface BackProps {
  icon?: string
  label: string
  href?: string | null
  onClick?: (() => void) | null
}

const props = withDefaults(defineProps<BackProps>(), {
  icon: 'chevron-left',
  href: null,
  onClick: null,
})

function goBack() {
  history.go(-1)
}
</script>
